<template>
    <div>
        <a-modal :title="modalTitle" v-model="visible" :confirm-loading="confirmLoading" width="800px" @cancel="handleCancel">
            <a-form-model :model="formData" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol" class="myForm">
                <p class="form_title">基础配置</p>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item ref="jobGroup" label="执行器" prop="jobGroup">
                            <a-select mode="default" v-model="formData.jobGroup" placeholder="请选择执行器" show-search>
                                <a-select-option v-for="item in JobGroupList" :key="item.id">
                                    {{ item.title }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="jobDesc" label="任务标题" prop="jobDesc">
                            <a-input v-model="formData.jobDesc" placeholder="请输入任务标题" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col :span="12">
                        <a-form-model-item ref="author" label="负责人" prop="author">
                            <a-input v-model="formData.author" placeholder="请输入负责人" />
                        </a-form-model-item>
                    </a-col>
                    <!-- <a-col :span="12">
                        <a-form-model-item ref="alarmEmail" label="钉钉机器人" prop="alarmEmail">
                            <a-input v-model="formData.alarmEmail" placeholder="请输入钉钉机器人TOKEN(以逗号隔开支持2个)" />
                        </a-form-model-item>
                    </a-col> -->
                    <a-col :span="12">
                        <a-form-model-item ref="appCode" label="appCode" prop="appCode">
                            <AppAutoCompleteNew v-model="formData.appCode"></AppAutoCompleteNew>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col :span="12">
                        <a-form-model-item ref="jobRemark" label="jobRemark" prop="jobRemark">
                            <a-input v-model="formData.jobRemark" placeholder="请输入备注" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="authortel" label="负责人手机号" prop="authortel">
                            <a-input v-model="formData.authortel" placeholder="请输入负责人手机号" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item ref="version" label="版本" prop="version">
                            <a-radio-group v-model="formData.version">
                                <a-radio value="V3.0">
                                    3.0
                                </a-radio>
                                <a-radio value="V5.0">
                                    5.0
                                </a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <p class="form_title">调度配置</p>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item ref="scheduleType" label="调度类型" prop="scheduleType">
                            <a-select mode="default" v-model="formData.scheduleType" placeholder="请选择调度类型" show-search>
                                <a-select-option v-for="item in ScheduleTypeEnum" :key="item.name">
                                    {{ item.title }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item v-if="formData.scheduleType == 'CRON'" ref="schedule_conf_CRON" label="Cron" prop="schedule_conf_CRON">
                            <j-cron v-model="schedule_conf_CRON"></j-cron>

                        </a-form-model-item>

                        <a-form-model-item v-if="formData.scheduleType == 'FIX_RATE'" ref="schedule_conf_FIX_RATE" label="固定速度" prop="schedule_conf_FIX_RATE">
                            <a-input type="number" v-model="schedule_conf_FIX_RATE" placeholder="请输入（ Second ）" />
                        </a-form-model-item>

                        <a-form-model-item v-if="formData.scheduleType == 'FIX_DELAY'" ref="schedule_conf_FIX_DELAY" label="固定延迟" prop="schedule_conf_FIX_DELAY">
                            <a-input type="number" v-model="schedule_conf_FIX_DELAY" placeholder="请输入（ Second ）" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <p class="form_title">任务配置</p>
                <a-row>
                    <!-- <a-col :span="12">

                        <a-form-model-item ref="glueType" label="运行模式" prop="glueType">
                            <a-select mode="default" v-model="formData.glueType" placeholder="运行模式" show-search>
                                <a-select-option v-for="item in GlueTypeEnum" :key="item.name">
                                    {{ item.desc }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col> -->
                    <a-col :span="12">

                        <a-form-model-item ref="executorHandler" label="JobHandler" prop="executorHandler">
                            <a-select mode="default" v-model="formData.executorHandler" show-search>
                                <a-select-option key="commonJob">
                                    commonJob
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item ref="executorParam" label="servicekey/URL" prop="executorParam" :label-col="{span: 4}" :wrapper-col="{span: 18}">
                            <a-input v-model="formData.executorParam" placeholder="请选择服务servicekey 或输入全路径" />

                        </a-form-model-item>

                    </a-col>
                    <a-button type="link" class="extra_input_btn" @click="handleServicekeyModal">+选择服务</a-button>
                    <ServiceKeySelecter :modalState="modalStateServicekey" @onModalHide="onServiceKeyselecterHide"></ServiceKeySelecter>
                </a-row>
                <p class="form_title mt10">高级配置</p>

                <a-row>
                    <a-col :span="12">

                        <a-form-model-item ref="executorRouteStrategy" label="路由策略" prop="executorRouteStrategy">
                            <a-select mode="default" v-model="formData.executorRouteStrategy" placeholder="路由策略" show-search>
                                <a-select-option v-for="item in ExecutorRouteStrategyEnum" :key="item.name">
                                    {{ item.title }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="childJobId" label="子任务ID" prop="childJobId">
                            <a-input v-model="formData.childJobId" placeholder="请输入子任务ID" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col :span="12">
                        <a-form-model-item ref="misfireStrategy" label="调度过期策略" prop="misfireStrategy">
                            <a-select mode="default" v-model="formData.misfireStrategy" placeholder="调度过期策略" show-search>
                                <a-select-option v-for="item in MisfireStrategyEnum" :key="item.name">
                                    {{ item.title }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">

                        <a-form-model-item ref="executorBlockStrategy" label="阻塞处理策略" prop="executorBlockStrategy">
                            <a-select mode="default" v-model="formData.executorBlockStrategy" placeholder="阻塞处理策略" show-search>
                                <a-select-option v-for="item in ExecutorBlockStrategyEnum" :key="item.name">
                                    {{ item.title }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col :span="12">
                        <a-form-model-item ref="executorTimeout" label="任务超时时间" prop="executorTimeout">
                            <a-input type="number" v-model="formData.executorTimeout" placeholder="任务超时时间，单位秒，大于零时生效" :maxLength="6" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="executorFailRetryCount" label="失败重试次数" prop="executorFailRetryCount">
                            <a-input type="number" v-model="formData.executorFailRetryCount" placeholder="失败重试次数，大于零时生效" :maxLength="4" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <p class="form_title mt10">
                    动态参数
                    <a-button style="float:right" type="link" @click="handleAddParam">+添加</a-button>
                </p>

                <a-row v-for="(item,index) in jobParams" :key="index">

                    <a-col :span="8">
                        <a-form-model-item :label="(index+1) + '.    ' + 'KEY'">
                            <a-input v-model="item.key" placeholder="KEY" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="VALUE">
                            <a-input v-model="item.val" placeholder="VALUE" />
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="4">
                        <a-button class="mt7" type="link" @click="handleDelete(index)">删除</a-button>
                    </a-col>
                </a-row>
            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    保存
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import AppAutoCompleteNew from '@/components/AppAutoCompleteNew'
import JCron from '@/components/jeecg/JCron.vue'
import ServiceKeySelecter from '@/components/ServiceKeySelecter'

export default {
    components: {
        JCron,
        AppAutoCompleteNew,
        ServiceKeySelecter,
    },
    data() {
        return {
            rules: {
                jobGroup: [
                    {
                        required: true,
                        message: '请选择执行器',
                        trigger: 'blur',
                    },
                ],
                jobDesc: [
                    {
                        required: true,
                        message: '请输入任务标题',
                        trigger: 'blur',
                    },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],
                author: [
                    {
                        required: true,
                        message: '请输入负责人',
                        trigger: 'blur',
                    },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],
                // alarmEmail: [
                //     {
                //         required: true,
                //         message: '请输入钉钉机器人TOKEN',
                //         trigger: 'blur',
                //     },
                //     { max: 200, message: '不能超过200位', trigger: 'blur' },
                // ],

                appCode: [
                    {
                        required: true,
                        message: '请输入appCode',
                        trigger: 'blur',
                    },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],

                jobRemark: [
                    { max: 100, message: '不能超过100位', trigger: 'blur' },
                ],

                authortel: [
                    {
                        required: true,
                        message: '请输入负责人手机号',
                        trigger: 'blur',
                    },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],

                version: [
                    { required: true, message: '请选择版本', trigger: 'blur' },
                ],

                schedule_conf_CRON: [
                    { max: 128, message: '不能超过128位', trigger: 'blur' },
                ],
                schedule_conf_FIX_RATE: [
                    { max: 10, message: '不能超过10位', trigger: 'blur' },
                ],

                schedule_conf_FIX_DELAY: [
                    { max: 10, message: '不能超过10位', trigger: 'blur' },
                ],

                // glueType: [
                //     {
                //         required: true,
                //         message: '请选择运行模式',
                //         trigger: 'blur',
                //     },
                // ],

                childJobId: [
                    { max: 100, message: '不能超过10位', trigger: 'blur' },
                ],

                executorParam: [
                    { required: true, message: '请填写', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
            formItemLayout: 'inline',
            visible: false,
            modalTitle: '新增',
            //备用与绑定字段
            schedule_conf_CRON: '* * * * * ? *', //
            schedule_conf_FIX_RATE: '',
            schedule_conf_FIX_DELAY: '',

            jobParams: [],

            formData: {
                id: '',
                jobGroup: '',
                jobDesc: '',
                author: '',
                // alarmEmail: '',
                appCode: '',
                jobRemark: '',
                authortel: '',
                version: 'V3.0',
                scheduleType: 'CRON',
                scheduleConf: '',
                // glueType: '',
                executorHandler: 'commonJob',
                executorParam: '',
                executorRouteStrategy: '',
                misfireStrategy: '',
                childJobId: '',
                executorBlockStrategy: '',
                executorTimeout: 0,
                executorFailRetryCount: 0,
                jobParam: '',
            },
            JobGroupList: [],
            ScheduleTypeEnum: [],
            MisfireStrategyEnum: [],
            ExecutorRouteStrategyEnum: [],
            ExecutorBlockStrategyEnum: [],
            modalStateServicekey: {
                isShow: false,
                rowsType: 'radio',
                domain: '',
                selectkeys: [],
            },
        }
    },
    methods: {
        handleDelete(index) {
            let tempS = this.jobParams.slice(0, index)
            let tempE = this.jobParams.slice(index + 1, this.jobParams.length)
            this.jobParams = tempS.concat(tempE)
        },
        handleAddParam() {
            this.jobParams.push({
                key: '',
                val: '',
            })
        },
        submitParam() {
            let result = {}
            this.jobParams.forEach((element) => {
                result[element.key] = element.val
            })
            this.formData.jobParam = JSON.stringify(result)
        },
        handleServicekeyModal() {
            this.modalStateServicekey.filterServicekey = []
            this.modalStateServicekey.isShow = true
        },
        onServiceKeyselecterHide(result) {
            if (result == undefined) {
                this.modalStateServicekey.isShow = false
                return
            }
            this.formData.executorParam = result[0].servicekey
            this.modalStateServicekey.isShow = false
        },
        //初始化
        onModalInit(record, obj, action) {
            const {
                JobGroupList,
                ScheduleTypeEnum,
                MisfireStrategyEnum,
                ExecutorRouteStrategyEnum,
                ExecutorBlockStrategyEnum,
            } = obj
            this.ScheduleTypeEnum = ScheduleTypeEnum

            this.ExecutorRouteStrategyEnum = ExecutorRouteStrategyEnum
            if (ExecutorRouteStrategyEnum.length > 0) {
                this.formData.executorRouteStrategy =
                    ExecutorRouteStrategyEnum[0].name
            }
            this.ExecutorBlockStrategyEnum = ExecutorBlockStrategyEnum
            if (ExecutorBlockStrategyEnum.length > 0) {
                this.formData.executorBlockStrategy =
                    ExecutorBlockStrategyEnum[0].name
            }
            this.MisfireStrategyEnum = MisfireStrategyEnum
            if (MisfireStrategyEnum.length > 0) {
                this.formData.misfireStrategy = MisfireStrategyEnum[0].name
            }
            // this.GlueTypeEnum = GlueTypeEnum
            // if (GlueTypeEnum.length > 0) {
            //     this.formData.glueType = GlueTypeEnum[0].name
            // }
            this.JobGroupList = JobGroupList
            if (JobGroupList.length > 0) {
                this.formData.jobGroup = JobGroupList[0].id
            }
            if (action == 'add') {
                this.formData.id = undefined
                //新增
                this.modalTitle = '新增'
                this.jobParams = []
            } else {
                if (action == 'copy') {
                    this.modalTitle = '复制'
                    this.formData.id = undefined
                } else {
                    //编辑
                    this.modalTitle = '编辑'
                    this.formData.id = record.id
                }
                this.formData.jobGroup = record.jobGroup
                this.formData.jobDesc = record.jobDesc
                this.formData.author = record.author
                // this.formData.alarmEmail = record.alarmEmail
                this.formData.appCode = record.appCode
                this.formData.jobRemark = record.jobRemark
                this.formData.authortel = record.authortel
                this.formData.version = record.version
                this.formData.scheduleType = record.scheduleType
                this.formData.scheduleConf = record.scheduleConf
                this.formData.executorHandler = record.executorHandler
                this.formData.executorParam = record.executorParam
                this.formData.executorRouteStrategy =
                    record.executorRouteStrategy
                this.formData.misfireStrategy = record.misfireStrategy
                this.formData.childJobId = record.childJobId
                this.formData.executorBlockStrategy =
                    record.executorBlockStrategy
                this.formData.executorTimeout = record.executorTimeout
                this.formData.executorFailRetryCount =
                    record.executorFailRetryCount
                this.formData.jobParam = record.jobParam

                if (this.formData.scheduleType == 'NONE') {
                    this.formData.scheduleConf = ''
                }
                if (this.formData.scheduleType == 'CRON') {
                    this.schedule_conf_CRON = this.formData.scheduleConf
                } else if (this.formData.scheduleType == 'FIX_RATE') {
                    this.schedule_conf_FIX_RATE = this.formData.scheduleConf
                } else if (this.formData.scheduleType == 'FIX_DELAY') {
                    this.schedule_conf_FIX_DELAY = this.formData.scheduleConf
                }
                if (record.jobParam) {
                    let result = []
                    let temp = []
                    try {
                        temp = JSON.parse(record.jobParam)
                    } catch (e) {
                        temp = []
                    }

                    for (const key in temp) {
                        if (temp.hasOwnProperty(key)) {
                            const element = temp[key]
                            result.push({
                                key: key,
                                val: element,
                            })
                        }
                    }
                    this.jobParams = result
                }
            }
            this.visible = true
        },
        //提交
        handleOk() {
            let that = this
            //组装动态参数
            that.submitParam()
            //组装部分数据
            if (that.formData.scheduleType == 'NONE') {
                that.formData.scheduleConf = ''
            }
            if (that.formData.scheduleType == 'CRON') {
                that.formData.scheduleConf = that.schedule_conf_CRON
            } else if (that.formData.scheduleType == 'FIX_RATE') {
                that.formData.scheduleConf = that.schedule_conf_FIX_RATE
            } else if (that.formData.scheduleType == 'FIX_DELAY') {
                that.formData.scheduleConf = that.schedule_conf_FIX_DELAY
            } else {
                that.formData.scheduleConf = ''
            }
            that.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    that.confirmLoading = true
                    let typeName =
                        this.formData.id == undefined ? 'add' : 'update'
                    that.$store
                        .dispatch({
                            type: 'jobcenter/' + typeName,
                            params: {
                                ...that.formData,
                                urlparams: false,
                            },
                        })
                        .then((res) => {
                            if (res.data.code == '200') {
                                that.message.success('操作成功')
                                that.handleCancel()
                            } else {
                                that.message.error(res.data.msg)
                            }
                            that.confirmLoading = false
                        })
                } else {
                    return false
                }
            })
        },
        //取消
        handleCancel() {
            this.resetForm()
            this.visible = false
            this.$emit('onModalHide', '')
        },
        //重置
        resetForm() {
            this.schedule_conf_CRON = '* * * * * ? *'
            this.schedule_conf_FIX_RATE = ''
            this.schedule_conf_FIX_DELAY = ''

            this.jobParams = []

            this.formData = {
                id: '',
                jobGroup: '',
                jobDesc: '',
                author: '',
                // alarmEmail:'',
                appCode: '',
                jobRemark: '',
                authortel: '',
                version: 'V3.0',
                scheduleType: 'CRON',
                scheduleConf: '',
                executorHandler: 'commonJob',
                executorParam: '',
                executorRouteStrategy: '',
                misfireStrategy: '',
                childJobId: '',
                executorBlockStrategy: '',
                executorTimeout: 0,
                executorFailRetryCount: 0,
                jobParam: '',
            }
            this.JobGroupList = []
            this.ScheduleTypeEnum = []
            // this.GlueTypeEnum = []
            this.MisfireStrategyEnum = []
            this.ExecutorRouteStrategyEnum = []
            this.ExecutorBlockStrategyEnum = []
            this.$refs.ruleForm.resetFields()
        },
    },
}
</script>

<style scoped>
.myForm {
    max-width: 800px;
}
.ant-form-item {
    display: flex;
    padding: 4px 0;
}
.form_title {
    border-bottom: 1px solid lightgray;
    padding-bottom: 10px;
}

.form-label-my {
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
}

.extra_input_btn {
    position: absolute;
    right: 0;
    top: 6px;
}
</style>
<style>
.ant-modal-body {
    padding: 12px 24px 24px 24px !important;
}
</style>
